type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object
    ? T[K] extends Array<unknown>
      ? T[K]
      : DeepPartial<T[K]>
    : T[K]
}

function deepMerge<T extends Record<string, unknown>>(
  defaults: T,
  overrides: DeepPartial<T>,
): T {
  const result = { ...defaults }
  for (const key of Object.keys(overrides) as Array<keyof T>) {
    const val = overrides[key]
    if (val === undefined) continue
    if (
      typeof val === 'object' &&
      val !== null &&
      !Array.isArray(val) &&
      typeof defaults[key] === 'object' &&
      defaults[key] !== null &&
      !Array.isArray(defaults[key])
    ) {
      result[key] = deepMerge(
        defaults[key] as Record<string, unknown>,
        val as DeepPartial<Record<string, unknown>>,
      ) as T[keyof T]
    } else {
      result[key] = val as T[keyof T]
    }
  }
  return result
}

export { deepMerge, type DeepPartial }
